// extracted by mini-css-extract-plugin
export var centerText = "_62-8";
export var container = "_62-0";
export var doughnutContainer = "_62-7";
export var legend = "_62-a";
export var legendItemColorDisplay = "_62-b";
export var legendItemLabel = "_62-d";
export var legendItemValue = "_62-c";
export var lg = "_62-5";
export var maxWidth = "_62-9";
export var md = "_62-4";
export var responsive = "_62-6";
export var sm = "_62-3";
export var xs = "_62-2";
export var xxs = "_62-1";